export const reloadLocation = () => {
  location.href = '/users/accounts';
}
